module.exports = __webpack_public_path__ + "media/ty_m.d9d81fb8.mp3";